import * as React from 'react';
import { Card } from '@mui/material';
import { styled } from '@mui/system';
import AvatarUpload from './components/AvatarUpload';
import UserSettingPanel from './components/UserSettingPanel';
import { Navigate } from 'react-router-dom';
import { useEffect, useContext } from 'react';
import { AppContext } from '../../context/ContextProvider';

const UserSettingContainer = styled(Card)(({ theme }) => ({
  display: 'flex',
  margin: '50px auto 25px',
  maxWidth: '827px',
  minHeight: '626px',
  gap: '40px',
  padding: '16px 27px 0',
  borderRadius: '0',
  boxShadow: 'none',
  background:
    'linear-gradient(250.42deg, rgba(255, 255, 255, 0.32) 0%, rgba(255, 255, 255, 0.08) 101.65%)',
  border: '1px solid #ffff',
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
  },
  [theme.breakpoints.down('sm')]: {
    border: 'none',
    background: 'none',
    padding: '0',
  },
}));

export default function UserSettingPage() {
  const { isShow, setIsShow, isLogin, setIsLogin } = useContext(AppContext);
  useEffect(() => {
    if (!isLogin) {
      setIsShow(false);
    }
  }, [isLogin, isShow]);

  return isLogin ? (
    <UserSettingContainer elevation={3}>
      <AvatarUpload />
      <UserSettingPanel />
    </UserSettingContainer>
  ) : (
    <Navigate to="/sigin" />
  );
}
